var f = Object.defineProperty;
var o = (n, s, e) => s in n ? f(n, s, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[s] = e;
var l = (n, s, e) => o(n, typeof s != "symbol" ? s + "" : s, e);
class c {
  constructor() {
    l(this, "listeners", {});
  }
  emit(s, e) {
    const i = this.listeners[s];
    i && (this.listeners[s] = i.filter((t) => !t.once), i.map((t) => t.fn(e)).map((t) => typeof t == "function" && (t == null ? void 0 : t())));
  }
  off(s, e) {
    const i = this.listeners[s];
    i && (this.listeners[s] = i.filter((r) => r.fn !== e));
  }
  on(s, e) {
    this.add(s, e, !1);
  }
  once(s, e) {
    this.add(s, e, !0);
  }
  reset() {
    this.listeners = {};
  }
  add(s, e, i) {
    const r = this.listeners[s], t = { fn: e, once: i };
    r ? r.push(t) : this.listeners[s] = [t];
  }
}
export {
  c as E
};
